import {Component} from "@angular/core";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: "app-scene-block-switch",
    templateUrl: "./block-switch.component.html",
    styleUrls: ["./block-switch.component.scss"]
})
export class BlockSwitchComponent extends BlockBaseComponent {

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: "",
                label: this.translocoService.translate("general.onLabel", {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "onLabel",
                storePath: "Data[0].Switch[0].$.onLabel"
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate("general.offLabel", {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "offLabel",
                storePath: "Data[0].Switch[0].$.offLabel"
            },
            {
                type: "checkbox",
                value: "false",
                label: this.translocoService.translate("general.defaultValue", {}, this.translocoService.getActiveLang()),
                name: "defaultValue",
                options: ["false", "true"],
                storePath: "Data[0].Switch[0].$.defaultValue"
            },
            {
                type: "input",
                value: "",
                label: this.translocoService.translate("general.fieldName", {}, this.translocoService.getActiveLang()),
                name: "fieldName",
                inputType: "text",
                storePath: "Data[0].Switch[0].$.fieldName"
            }
        ];
    }
}

